"use client";

export function AgeGateEnter({ storageKey, label }: { storageKey: string; label: string }) {
  return (
    <button
      type="button"
      autoFocus
      onClick={() => {
        try {
          localStorage.setItem(storageKey, "ok");
        } catch {
          // Storage blocked: still let the visitor in for this page view.
        }
        document.documentElement.dataset.age = "ok";
      }}
      className="h-12 rounded-full bg-brand-strong text-[15px] font-medium text-white shadow-[0_10px_30px_-8px_rgb(255_46_126/0.7)] transition-colors hover:bg-brand-deep"
    >
      {label}
    </button>
  );
}
